import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstDischargeSpecialInstructionService {
    mstDischargeSpecialInstruction: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_discharge_special_instruction/list?';
    private ListRecordByDischargeSpInstructionGroup = webapi + 'mst_discharge_special_instruction/listbydischargespinstructiongroup/';
    private AddRecord = webapi + 'mst_discharge_special_instruction/create';
    private EditRecord = webapi + 'mst_discharge_special_instruction/update';
    private GetRecord = webapi + 'mst_discharge_special_instruction/byid/';
    private DeleteRecord = webapi + 'mst_discharge_special_instruction/delete/';
    private GetDropDown = webapi + 'mst_discharge_special_instruction/dropdown?';
    private ListAllRecord = webapi + 'mst_discharge_special_instruction/alllist/';
    private ReActiveRecord = webapi + 'mst_discharge_special_instruction/reActive/';
    private DeListRecord = webapi + 'mst_discharge_special_instruction/deactivated_list/?';
    private SearchTables = webapi + 'mst_discharge_special_instruction/searchTables?';
    private Listbydischargespinstructiongroup = webapi + 'mst_discharge_special_instruction/listbydischargespinstructiongroup/';


    constructor(
        private http: Http
    ) {
    }

    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getListbydischargespinstructiongroup(id: any) {
        return this.http.get(this.Listbydischargespinstructiongroup + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByDischargeSpInstructionGroup(dsgId: any): Promise<any> {
        return this.http.get(this.ListRecordByDischargeSpInstructionGroup + dsgId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDropDown(currentPage: any, size: any, dsgId: any, globalFilter: any): Promise<any> {
        return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&dsgId=' + dsgId + '&globalFilter=' + globalFilter)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecords(): Promise<any> {
        return this.http.get(this.ListAllRecord)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-discharge-special-instruction/mst-discharge-special-instruction.service.ts